import { ListItemPropertiesType } from "@website/ui/list-item/list-item.types";
import pick from "lodash-es/pick";

export const useListItem = (properties: ListItemPropertiesType) => {
  const { href, target, onClick, role, disabled } = properties;

  return {
    rootProps: {
      default: {
        ...pick(properties, "aria-label")
      },
      button: {
        ...pick(properties, "aria-label"),
        role,
        onClick,
        disabled,
        tabIndex: 0,
        type: "button"
      },
      link: {
        ...pick(properties, "aria-label"),
        role,
        href,
        target,
        tabIndex: 0
      }
    }
  };
};
